const getButtonKey = (item) => {
    const newkey = (['primary', 'secondary', 'brandHighlight'].includes(item.kind)
        ? 'button'
        : item.kind) + (item.kind !== 'textLinkCaret' ? item.size : '');
    return newkey.toLowerCase();
};
const buttonSpacingMap = {
    buttonlarge: {
        buttonlarge: { horizontal: 12, vertical: 12 },
        textlinkcaret: { horizontal: 24, vertical: 24 },
        textlinklarge: { horizontal: 16, vertical: 16 },
    },
    textlinklarge: {
        buttonlarge: { horizontal: 16, vertical: 16 },
        textlinkcaret: { horizontal: 24, vertical: 24 },
        textlinklarge: { horizontal: 16, vertical: 24 },
    },
    textlinkcaret: {
        buttonlarge: { horizontal: 24, vertical: 24 },
        textlinkcaret: { horizontal: 24, vertical: 24 },
        textlinklarge: { horizontal: 24, vertical: 24 },
    },
    buttonsmall: {
        buttonsmall: { horizontal: 12, vertical: 12 },
        textlinksmall: { horizontal: 16, vertical: 24 },
    },
    textlinksmall: {
        buttonsmall: { horizontal: 16, vertical: 24 },
        textlinksmall: { horizontal: 16, vertical: 32 },
    },
};
const getHorizontalSpacing = (currentKey, nextKey) => !currentKey || !nextKey
    ? 0
    : buttonSpacingMap[currentKey][nextKey].horizontal;
const getVerticalSpacing = (currentKey, nextKey) => buttonSpacingMap[currentKey][nextKey].vertical;

export { buttonSpacingMap, getButtonKey, getHorizontalSpacing, getVerticalSpacing };
